import React from "react";

// Main URL
// https://www.googleapis.com/youtube/v3/search?key=AIzaSyCP_mWkFk_r9jgITDf2j8dVdO9A5RkHC9E&channel=UCzXwq43cFscWT4ZX9QbWwZw&part=snippet,id&order=date&maxResults=10

// URL channel ID, API Key, max num of videos to display (in JSON)
const channelId = "UCzXwq43cFscWT4ZX9QbWwZw";
const apiKey = "AIzaSyCP_mWkFk_r9jgITDf2j8dVdO9A5RkHC9E";
const numVideos = 10;

// Complete URL
const url = `https://www.googleapis.com/youtube/v3/search?key=${apiKey}&channelId=${channelId}&part=snippet,id&order=date&maxResults=${numVideos}`;

class VideoList extends React.Component {
  // Blank video state
  state = {
    videos: [],
    titles: [],
    desc: [],
  };

  //When component mounts, make Youtube API call...
  componentDidMount() {
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //Create list of youtube links by concatenating each videoID in the JSON object
        const videos = response.items.map(
          (obj) => "https://www.youtube.com/embed/" + obj.id.videoId
        );
        this.setState({ videos });
        const titles = response.items.map((obj) => obj.snippet.title);
        this.setState({ titles });
        const desc = response.items.map((obj) => obj.snippet.description);
        this.setState({ desc });

        // console.log(list);
      })
      .catch((error) => console.error(error));
  }

  render() {
    return (
      <main class="container">
        <h2>Episodes</h2>

        <section style={myStyle}>
          {this.state.videos.map((list, i) => {
            //Call the videos in state...
            const video = (
              <div className="episodeDiv" style={vidStyle} key={i}>
                {console.log(this.state.titles[i])}
                <h3>{this.state.titles[i]}</h3>
                <iframe
                  width="560"
                  height="315"
                  src={list}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <p>{this.state.desc[i]}</p>
              </div>
            );
            // ...and list them out in individual divs
            return video;
          })}
        </section>
      </main>
    );
  }
}

const myStyle = {
  backgroundColor: "rgba(236, 236, 233, 1)",
  marginTop: "2rem",
};

const vidStyle = {
  padding: "0",
  margin: "0 auto",
};

export default VideoList;
